import { OrderStepProgress } from '@core/enums';
import brand from '@helpers/brand';
import { fonts } from '@helpers/fonts';
import { rgba } from 'polished';
import SiteWide from '@stories/Components/Containers/SiteWide/SiteWide';
import styled, { css, keyframes } from 'styled-components';
import { Device, from } from '@helpers/media';
const rgbaGrey55 = rgba(brand.grey.grey55, 0.75);
const KeyframeFillComplete = keyframes `
  0% {
    color: ${brand.primary.base};
    background-color: none;
  }
  100% {
    color: ${brand.white};
    background-color: ${brand.primary.base};
  }
`;
const Bar = styled(SiteWide) `
  display: flex;
  align-items: flex-start;
  justify-content: space-evenly;
  margin: 18px auto;

  @media ${from(Device.Tablet)} {
    margin: 50px auto;
  }
`;
const Step = styled.a `
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;

  &:hover,
  &:active,
  &:focus {
    text-decoration: none;
  }

  &:after {
    content: '';
    display: block;
    position: absolute;
    z-index: 0;
    top: 19px;
    margin-top: -1px;
    left: 50%;
    width: 100%;
    height: 2px;
    border-bottom: 2px solid ${rgbaGrey55};

    @media ${from(Device.Tablet)} {
      top: 30px;
    }
  }

  &:last-child:after {
    display: none;
  }

  ${({ currentProgress }) => {
    switch (currentProgress) {
        default:
        case OrderStepProgress.Inactive:
            return css `
          ${() => Number} {
            border-color: ${rgbaGrey55};
            color: ${rgbaGrey55};
          }
          ${() => Text} {
            color: ${rgbaGrey55};
          }
        `;
        case OrderStepProgress.Complete:
            return css `
          &:after {
            border-color: ${brand.primary.base};
          }

          ${() => Number} {
            border-color: ${brand.primary.base};
            color: ${brand.white};
            background-color: ${brand.primary.base};
          }
          ${() => Text} {
            color: ${brand.grey.grey55};
          }
        `;
        case OrderStepProgress.Current:
            return css `
          ${() => Number} {
            border-color: ${brand.primary.base};
            color: ${brand.primary.base};
          }
          ${() => Text} {
            color: ${brand.primary.base};
          }
        `;
    }
}}
`;
const Number = styled.div `
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 38px;
  width: 38px;
  font-size: 16px;
  line-height: 16px;
  ${fonts.DaxPro['Medium']};
  background-color: ${brand.white};
  border-radius: 50%;
  margin-bottom: 12px;
  border: 2px solid transparent;
  z-index: 2;

  @media ${from(Device.Tablet)} {
    font-size: 22px;
    line-height: 22px;
    height: 60px;
    width: 60px;
  }

  ${({ animateProgressFill }) => animateProgressFill &&
    css `
      animation: ${KeyframeFillComplete} 500ms linear forwards 750ms;
    `}
`;
const Text = styled.div `
  font-size: 14px;
  line-height: 1.2;
  ${fonts.DaxPro['Medium']};
  text-align: center;

  @media ${from(Device.Tablet)} {
    font-size: 16px;
  }
`;
export const OrderProgressBarStyles = {
    Bar,
    Step,
    Number,
    Text,
};
